import { render, staticRenderFns } from "./FormCasdastroComponent.vue?vue&type=template&id=2b91aec6&scoped=true&"
import script from "./FormCasdastroComponent.vue?vue&type=script&lang=js&"
export * from "./FormCasdastroComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormCasdastroComponent.vue?vue&type=style&index=0&id=2b91aec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b91aec6",
  null
  
)

export default component.exports